import http from "./httpService";
const apiUrl = require("../config.json").apiUrl;
// import  apiUrl  from ".././config.json";

export const getbookinghistory = (data) => {
    const apiEndPoint = `${apiUrl}/PublicBookedHistory`;
    return http.post(`${apiEndPoint}`,data);
  };


  export const PublicOthersBookedHistory = (data) => {
    const apiEndPoint = `${apiUrl}/PublicOthersBookedHistory`;
    return http.post(`${apiEndPoint}`, data);
  };
  